import { render, staticRenderFns } from "./OpenedTick.vue?vue&type=template&id=7bd57e90&"
import script from "./OpenedTick.vue?vue&type=script&lang=js&"
export * from "./OpenedTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports